import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { createInquiry } from "../lib/api";
import { IMAGES } from "../lib/menuData";

const inputCls =
  "w-full bg-cream/[0.04] border border-gold/25 rounded-sm px-4 py-3 text-cream placeholder-cream/35 " +
  "focus:outline-none focus:border-gold focus:bg-cream/[0.07] transition-colors text-sm";

const Field = ({ label, children }) => (
  <label className="block">
    <span className="block text-xs uppercase tracking-[0.18em] text-gold/80 mb-2">{label}</span>
    {children}
  </label>
);

export const Reserve = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "Catering-Anfrage", date: "", guests: "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await createInquiry(form);
      toast.success("Anfrage gesendet! Wir melden uns schnellstmöglich.");
      setForm({ name: "", email: "", phone: "", subject: "Catering-Anfrage", date: "", guests: "", message: "" });
    } catch {
      toast.error("Etwas ist schiefgelaufen. Bitte versuche es erneut.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="kontakt" className="relative py-24 md:py-36 grain overflow-hidden">
      <img src={IMAGES.spices} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-teal-dark/92" />
      <div className="relative z-10 max-w-3xl mx-auto px-5 md:px-10">
        <div className="text-center flex flex-col items-center">
          <Overline className="mb-5 justify-center">Kapitel III — Catering & Kontakt</Overline>
          <Reveal>
            <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl text-cream leading-tight max-w-2xl">
              Plane dein Event oder <span className="italic text-gold">schreib uns</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-5 text-cream/65 max-w-lg">
              Ob Catering für deine Feier oder eine allgemeine Frage – deine Nachricht landet
              direkt bei unserem Team.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="mt-10 bg-teal-deep/60 backdrop-blur border border-gold/20 rounded-lg p-7 md:p-10">
            <form onSubmit={submit} data-testid="catering-form" className="space-y-5">
              <div className="grid sm:grid-cols-2 gap-5">
                <Field label="Name"><input required data-testid="cat-name" className={inputCls} value={form.name} onChange={set("name")} placeholder="Dein Name" /></Field>
                <Field label="Telefon (optional)"><input data-testid="cat-phone" className={inputCls} value={form.phone} onChange={set("phone")} placeholder="Telefonnummer" /></Field>
              </div>
              <Field label="E-Mail"><input required type="email" data-testid="cat-email" className={inputCls} value={form.email} onChange={set("email")} placeholder="name@email.de" /></Field>
              <div className="grid sm:grid-cols-2 gap-5">
                <Field label="Anlass / Betreff">
                  <select data-testid="cat-subject" className={inputCls} value={form.subject} onChange={set("subject")}>
                    <option>Catering-Anfrage</option>
                    <option>Private Feier</option>
                    <option>Firmenevent</option>
                    <option>Allgemeine Anfrage</option>
                  </select>
                </Field>
                <Field label="Personen (optional)"><input data-testid="cat-guests" className={inputCls} value={form.guests} onChange={set("guests")} placeholder="z. B. 30" /></Field>
              </div>
              <Field label="Wunschdatum (optional)"><input type="date" data-testid="cat-date" className={inputCls} value={form.date} onChange={set("date")} /></Field>
              <Field label="Nachricht"><textarea required rows="3" data-testid="cat-message" className={inputCls} value={form.message} onChange={set("message")} placeholder="Erzähl uns von deinem Event oder Anliegen ..." /></Field>
              <button type="submit" disabled={loading} data-testid="catering-submit-button"
                className="w-full flex items-center justify-center gap-2 bg-gold text-teal-dark font-medium py-3.5 rounded-full hover:bg-gold-light transition-colors disabled:opacity-60">
                {loading && <Loader2 size={18} className="animate-spin" />} Anfrage senden
              </button>
            </form>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
